import styled from 'styled-components'

export const SmallContainer = styled.div`
  text-align: center;
  width: 100%;
`
